module.exports = __webpack_public_path__ + "static/media/gathering-data.5f66da15.svg";